import { trpc } from '@/shared/api/trpc';

// Row-action mutations for the products table: update (visibility toggles +
// attachments), remove (soft delete), duplicate, move. All invalidate the
// list / byId / filterCounts reads on settle so the table + facet counts
// reflect the change. One instance per row — mirrors the itineraries
// `useItineraryMutations` pattern.
export const useProductRowMutations = () => {
  const utils = trpc.useUtils();
  const invalidate = () => {
    utils.products.list.invalidate();
    utils.products.byId.invalidate();
    utils.products.filterCounts.invalidate();
  };

  const update = trpc.products.update.useMutation({ onSettled: invalidate });
  const remove = trpc.products.remove.useMutation({ onSettled: invalidate });
  const duplicate = trpc.products.duplicate.useMutation({
    onSettled: invalidate,
  });
  const move = trpc.products.move.useMutation({ onSettled: invalidate });

  return { update, remove, duplicate, move };
};
